export enum State {
  INIT = 'init',

  CHOOSE_DOCUMENT_TYPE = 'choose-document-type',

  UPLOAD = 'upload',

  CHECK = 'check',
  SEND = 'send',
  DELETE = 'delete',

  REVIEW = 'review',

  DONE = 'done',
  ABORT = 'abort',
}
